import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_Field = _resolveComponent("Field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_Form = _resolveComponent("Form")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      (_ctx.hasAccess('TakeTeilnehmer.TakeSpecific'))
        ? (_openBlock(), _createBlock(_component_Form, { key: 0 }, {
            default: _withCtx(({ meta }) => [
              _cache[6] || (_cache[6] = _createElementVNode("h1", null, "Einnehmen eines anderen Teilnehmerkontexts", -1)),
              _cache[7] || (_cache[7] = _createElementVNode("span", null, "Es kann entweder die TeilnehmerId oder die TvsKundennummer angegeben werden. Wird die TvsKundennummer angegeben, so wird der erste Teilnehmer mit dieser Nummer genommen.", -1)),
              _createVNode(_component_v_form, {
                onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.takeSpecific(_ctx.teilnehmer)), ["prevent"]))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        md: "4",
                        sm: "6",
                        lg: "3"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, { class: "py-0" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Field, {
                                    name: "TeilnehmerId",
                                    rules: "numeric"
                                  }, {
                                    default: _withCtx(({ errors, field }) => [
                                      _createVNode(_component_v_text_field, _mergeProps(field, {
                                        modelValue: _ctx.teilnehmer.teilnehmerId,
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.teilnehmer.teilnehmerId) = $event)),
                                        modelModifiers: { number: true },
                                        label: "TeilnehmerId",
                                        placeholder: "TeilnehmerId",
                                        "error-messages": errors,
                                        disabled: _ctx.teilnehmer.tvsKundennummer > 0 || _ctx.teilnehmer.tvsLieferantennummer > 0
                                      }), null, 16, ["modelValue", "error-messages", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Field, {
                                    name: "TvsKundennummer",
                                    rules: "between:1000,9999|numeric"
                                  }, {
                                    default: _withCtx(({ errors, field }) => [
                                      _createVNode(_component_v_text_field, _mergeProps(field, {
                                        modelValue: _ctx.teilnehmer.tvsKundennummer,
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.teilnehmer.tvsKundennummer) = $event)),
                                        modelModifiers: { number: true },
                                        label: "TvsKundennummer",
                                        placeholder: "TvsKundennummer",
                                        "error-messages": errors,
                                        disabled: _ctx.teilnehmer.teilnehmerId > 0 || _ctx.teilnehmer.tvsLieferantennummer > 0
                                      }), null, 16, ["modelValue", "error-messages", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Field, {
                                    name: "TvsLieferantennummer",
                                    rules: "between:100,999|numeric"
                                  }, {
                                    default: _withCtx(({ errors, field }) => [
                                      _createVNode(_component_v_text_field, _mergeProps(field, {
                                        modelValue: _ctx.teilnehmer.tvsLieferantennummer,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.teilnehmer.tvsLieferantennummer) = $event)),
                                        modelModifiers: { number: true },
                                        label: "TvsLieferantennummer",
                                        placeholder: "TvsLieferantennummer",
                                        "error-messages": errors,
                                        disabled: _ctx.teilnehmer.teilnehmerId > 0 || _ctx.teilnehmer.tvsKundennummer > 0
                                      }), null, 16, ["modelValue", "error-messages", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Field, { name: "Rolle" }, {
                                    default: _withCtx(({ errors, field }) => [
                                      _createVNode(_component_v_select, _mergeProps(field, {
                                        modelValue: _ctx.teilnehmer.benutzerRolle,
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.teilnehmer.benutzerRolle) = $event)),
                                        items: _ctx.rolleItems,
                                        label: "Rolle",
                                        "error-messages": errors
                                      }), null, 16, ["modelValue", "items", "error-messages"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, { class: "pl-3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { sm: "2 pt-0 pb-5" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            type: "submit",
                            disabled: !meta.valid,
                            large: "",
                            color: "primary"
                          }, {
                            default: _withCtx(() => _cache[5] || (_cache[5] = [
                              _createTextVNode(" Set User ")
                            ])),
                            _: 2
                          }, 1032, ["disabled"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _cache[9] || (_cache[9] = _createElementVNode("h3", null, "Reset", -1)),
      _createVNode(_component_v_row, { class: "pl-3" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { sm: "2 pb-5" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                type: "secondary",
                large: "",
                color: "secondary",
                onClick: _ctx.reset
              }, {
                default: _withCtx(() => _cache[8] || (_cache[8] = [
                  _createTextVNode("Reset")
                ])),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}